/**
 * Audio streaming values shared by the worklet and the main-thread transport.
 * PCM stays as mono Float32 until it is serialized for the proxy.
 */
export const TARGET_SAMPLE_RATE = 16_000;
export const TARGET_CHANNEL_COUNT = 1;

export const PCM_FRAME_DURATION_MS = 20;
export const PCM_FRAME_SAMPLES =
  (TARGET_SAMPLE_RATE * PCM_FRAME_DURATION_MS) / 1_000;

export const PCM_FRAMES_PER_CHUNK = 10;
export const PCM_CHUNK_DURATION_MS =
  PCM_FRAME_DURATION_MS * PCM_FRAMES_PER_CHUNK;

export const MAX_BUFFERED_CHUNKS = 150;
export const MAX_BUFFERED_AUDIO_MS =
  MAX_BUFFERED_CHUNKS * PCM_CHUNK_DURATION_MS;
export const MAX_SOCKET_BUFFERED_BYTES = 1_000_000;

export const SOCKET_CONNECT_TIMEOUT_MS = 5_000;
export const SOCKET_HANDSHAKE_TIMEOUT_MS = 5_000;
export const SOCKET_BACKPRESSURE_POLL_MS = 50;
export const SOCKET_STOP_DRAIN_TIMEOUT_MS = 1_000;

export const RECONNECT_DELAYS_MS = [500, 1_000, 2_000, 4_000, 8_000, 10_000] as const;
export const RECONNECT_JITTER_RATIO = 0.2;

/** A convenient immutable view for callers that prefer a single config value. */
export const AUDIO_STREAMING_CONFIG = {
  targetSampleRate: TARGET_SAMPLE_RATE,
  targetChannelCount: TARGET_CHANNEL_COUNT,
  frameDurationMs: PCM_FRAME_DURATION_MS,
  frameSamples: PCM_FRAME_SAMPLES,
  framesPerChunk: PCM_FRAMES_PER_CHUNK,
  chunkDurationMs: PCM_CHUNK_DURATION_MS,
  maxBufferedChunks: MAX_BUFFERED_CHUNKS,
  maxBufferedAudioMs: MAX_BUFFERED_AUDIO_MS,
  maxSocketBufferedBytes: MAX_SOCKET_BUFFERED_BYTES,
  connectTimeoutMs: SOCKET_CONNECT_TIMEOUT_MS,
  handshakeTimeoutMs: SOCKET_HANDSHAKE_TIMEOUT_MS,
  backpressurePollMs: SOCKET_BACKPRESSURE_POLL_MS,
  stopDrainTimeoutMs: SOCKET_STOP_DRAIN_TIMEOUT_MS,
  reconnectDelaysMs: RECONNECT_DELAYS_MS,
  reconnectJitterRatio: RECONNECT_JITTER_RATIO,
} as const;
